import { render, staticRenderFns } from "./TableThumb.vue?vue&type=template&id=2d903583&scoped=true"
import script from "./TableThumb.vue?vue&type=script&lang=js"
export * from "./TableThumb.vue?vue&type=script&lang=js"
import style0 from "./TableThumb.vue?vue&type=style&index=0&id=2d903583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d903583",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
